<template>
  <div>
    <v-container>
      <div class="text-xs-right">
        <div>
          <v-btn outline @click="showsearch = true"><v-icon>search</v-icon>search</v-btn>
        </div>
        <importxlsx :loading="importloading" @onChange="onImport"></importxlsx>
        <v-btn :loading="exportloading" @click="exportxlsx" color="grey" outline>
          <em class="fas fa-file-export" />
          &nbsp; Export&nbsp;
        </v-btn>
        <v-btn @click="addData" depressed color="primary">ADD</v-btn>
      </div>
      <v-pagination
        :total-visible="15"
        v-model="pageNumber"
        @input="changePage"
        :length="pagelength"
      ></v-pagination>
      <v-data-table
        :headers="headers"
        :items="items"
        :loading="loading"
        hide-actions
        :pagination.sync="pagination"
        class="elevation-1"
      >
        <template v-slot:items="props">
          <tr>
            <td>
              {{ props.item.imei }}
            </td>
            <td>
              {{ props.item.points }}
            </td>
            <td>
              {{ props.item.description }}
            </td>
            <td>
              <span style="font-weight: bold; color: limegreen" v-if="props.item.status">
                แลกแล้ว
              </span>
              <span style="font-weigh: bold; color: grey" v-else>ยังไม่แลก</span>
            </td>

            <td class="text-xs-right">
              <v-btn @click="oneditData(props.item)" icon> <v-icon>edit</v-icon></v-btn>
              <v-btn @click="ondeleteData(props.item)" icon> <v-icon>delete</v-icon></v-btn>
            </td>
          </tr>
        </template>
      </v-data-table>
      <div>
        <v-dialog v-model="showEdit" persistent width="550px">
          <v-card v-if="showEdit">
            <ImeiEdit
              @onsave="onsave"
              @close="showEdit = false"
              :edittype="edittype"
              :editdata="editdata"
            ></ImeiEdit>
          </v-card>
        </v-dialog>
      </div>

      <v-dialog v-model="showsearch" width="500px" persistent>
        <v-card>
          <div style="float: right">
            <v-btn @click="showsearch = false" icon><v-icon>close</v-icon></v-btn>
          </div>
          <div class="pa-2 pt-4 pb-3">
            <div style="font-weight: 600; font-size: 20px"><v-icon>search</v-icon> ค้นหา</div>
            <div>
              <v-layout class="pa-0 ma-0" wrap row>
                <v-flex xs12 sm6 class="form-control pa-1">
                  <label>{{ $t('เลข IMEI') }}</label>
                  <input v-model="filter.imei" class="form-control" type="text" />
                </v-flex>
                <v-flex xs12 sm6 class="form-control pa-1">
                  <label>{{ $t('ข้อมูลเครื่อง') }}</label>
                  <input v-model="filter.description" class="form-control" type="text" />
                </v-flex>
                <v-flex xs6 sm6 class="form-control pa-1">
                  <label>{{ $t('สถานะการ Scan') }}</label>
                  <multiselect
                    :showLabels="false"
                    v-model="filter.status"
                    label="text"
                    :options="scanstatusoptions"
                  ></multiselect>
                </v-flex>

                <!-- <v-flex xs12 sm12 class="form-control pa-1">
                <label>{{ $t('สาขา') }}</label>
                <input v-model="filter.branch" class="form-control" type="text" />
              </v-flex> -->
              </v-layout>
            </div>
            <div class="text-xs-center">
              <v-btn @click="clearsearch" outline color="grey">Clear</v-btn>
              <v-btn @click="onsearch" color="primary">Search</v-btn>
            </div>
          </div>
        </v-card>
      </v-dialog>
    </v-container>
    <v-dialog v-model="reasondialog" width="500px">
      <v-card>
        <div class="pa-3 px-5">
          <div class="pb-3" style="font-weight: 600; font-size: 19px">เลข IMEI ซ้ำ</div>
          <div v-for="(item, k) in reason" :key="k">Row ที่ {{ item }}</div>
          <div class="text-center">
            <v-btn @click="reasondialog = false" color="primary">ปิด</v-btn>
          </div>
        </div>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import api from '@/api'
import importxlsx from '@/components/elements/importxlsx.vue'
import exportxlsx from '@/components/elements/exportxlsx.vue'
import multiselect from 'vue-multiselect'
import { mapGetters } from 'vuex'
import ImeiEdit from './ImeiEdit.vue'
import VueQr from 'vue-qr'
import XLSX from 'xlsx'
export default {
  components: {
    ImeiEdit,
    VueQr,
    importxlsx,
    exportxlsx,
    multiselect
  },
  data() {
    return {
      reason: '',
      reasondialog: false,
      scanstatusoptions: [
        { text: 'แลกแล้ว', value: true },
        { text: 'ยังไม่แลก', value: false }
      ],
      total: 0,
      offset: 0,
      limit: 10,
      pagetmp: 1,
      pageNumber: 1,
      qrlink: '',
      qrdialog: false,
      importloading: false,
      qrdata: '',
      showEdit: false,
      editdata: '',
      edittype: '',

      pagination: { rowsPerPage: -1, sortBy: 'branch_id' },
      columnName: '',
      items: [],
      filter: {
        imei: '',
        description: '',
        status: ''
      },
      exportloading: false,
      showsearch: false,
      loading: false,
      headers: [
        { text: 'เลข IMEI', value: 'imei' },
        { text: 'Coin ที่ได้รับ', value: 'points' },
        { text: 'ข้อมูลเครื่อง', value: 'description' },
        { text: 'สถานะการ Scan', value: 'status' },

        { text: '', value: '' }
      ]
    }
  },
  computed: {
    ...mapGetters(['selectedBot']),
    pagelength() {
      if (this.total) {
        return Math.ceil(this.total / 10)
      } else {
        return 1
      }
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    ondeleteData(item) {
      this.$swal
        .fire({
          text: 'ยืนยันการลบ ?',
          showCancelButton: true
        })
        .then((result) => {
          if (result.value) {
            this.loading = true
            var data = {
              ...item,
              pageid: this.selectedBot.pageid
            }
            api.deleteYasaleImei(data, (err, response) => {
              this.loading = false
              if (response.responsecode == 200) {
                this.getData()
                this.$swal.fire({
                  type: 'success',
                  text: 'สำเร็จ'
                })
              }
            })
          }
        })
    },
    clearsearch() {
      this.filter = {
        branchId: '',
        branchToaId: '',
        departmentStore: ''
      }
      this.getData()
      this.showsearch = false
    },
    onsearch() {
      this.getData()
      this.showsearch = false
    },
    async exportxlsx() {
      var data = {
        pageid: this.selectedBot.pageid
        // branchId: this.filter.branchId, // filter รหัสสาขาของห้าง
        // branchToaId: this.filter.branchToaId, // filter รหัสสาขา toa
        // departmentStore: this.filter.departmentStore, // filter ชื่อห้าง
        // branch: this.filter.branch, // filter ชื่อสาขา
        // offset: this.offset,
      }
      this.exportloading = true
      api.getYasaleImei(data, (err, response) => {
        var exporteddata = response.data

        var json = exporteddata.map((el) => {
          return {
            'เลข IMEI': el.imei,
            ข้อมูลเครื่อง: el.description,
            'Coin ที่ได้รับ': el.points
          }
        })

        const dataWS = XLSX.utils.json_to_sheet(json)
        const wb = XLSX.utils.book_new()
        XLSX.utils.book_append_sheet(wb, dataWS)
        XLSX.writeFile(wb, 'exportedimei' + '.xlsx')
        this.exportloading = false
      })
    },
    onImport(item) {
      this.importloading = true
      var data = {
        pageid: this.selectedBot.pageid,
        files: item[0]
      }

      api.importYasaleImei(data, async (response) => {
        this.importloading = false

        if (response.responsecode == 200) {
          await this.$swal.fire({
            text: 'สำเร็จ',
            type: 'success'
          })
        } else {
          this.reason = response.reason.split('Row ที่ ')
          this.reason.splice(0, 1)
          this.reasondialog = true
        }
        this.getData()
      })
    },
    changePage(val) {
      var vm = this
      if (this.pagetmp == val) {
        //dont do shit
      } else {
        this.pagetmp = val
        vm.offset = vm.pageNumber * this.limit - this.limit

        this.getData()
      }
    },
    oneditData(item) {
      this.editdata = item
      this.edittype = 'edit'
      this.showEdit = true
    },
    onsave() {
      this.showEdit = false
      this.getData()
    },
    gotolink(link) {
      this.$nextTick(() => {
        window.location.href = link
      })
      // location.assign(this.qrlink)
    },
    showQrcode(item) {
      this.qrdialog = true
      this.qrdata = item
    },
    addData() {
      this.edittype = 'create'
      this.showEdit = true
    },
    getData() {
      var data = {
        pageid: this.selectedBot.pageid,

        limit: this.limit,
        offset: this.offset
      }
      for (const key in this.filter) {
        if (this.filter[key]) {
          if (key == 'status') {
            Object.assign(data, { [key]: this.filter[key].value })
          } else {
            Object.assign(data, { [key]: this.filter[key] })
          }
        }
      }
      this.loading = true
      api.getYasaleImei(data, (err, response) => {
        this.loading = false
        this.items = response.data
        this.total = response.total
      })
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/yasale/imei/main.vue